'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ColumnMenu = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _agGridReact = require('ag-grid-react');

var _dataGridUtils = require('../dataGridUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var styles = {
    'rootFontSize': '10px',
    'fontSizeXSmall': '0.8rem',
    'fontSizeSmaller': '1.1rem',
    'fontSizeSmall': '1.2rem',
    'fontSizeMediumSmall': '1.3rem',
    'fontSizeMedium': '1.4rem',
    'fontSizeLarge': '1.6rem',
    'fontSizeLarger': '1.8rem',
    'fontSizeXLarge': '2rem',
    'fontSizeXxLarge': '3.2rem',
    'maxWidthMobile': '480px',
    'userMenuLayer': '3',
    'defaultBorderThickness': '1px',
    'taboola-svg-icon': 'ColumnMenu__taboola-svg-icon___QDAii',
    'item': 'ColumnMenu__item___2qBRA'
};
var ColumnMenu = exports.ColumnMenu = function ColumnMenu(props) {
    var column = props.column,
        api = props.api,
        _props$context = props.context;
    _props$context = _props$context === undefined ? {} : _props$context;
    var onColumnStateChanged = _props$context.onColumnStateChanged,
        _props$context$notPin = _props$context.notPinnedLabel,
        notPinnedLabel = _props$context$notPin === undefined ? 'Unpin' : _props$context$notPin,
        _props$context$leftPi = _props$context.leftPinnedLabel,
        leftPinnedLabel = _props$context$leftPi === undefined ? 'Pin Left' : _props$context$leftPi;

    var _useState = (0, _react.useState)(),
        _useState2 = _slicedToArray(_useState, 2),
        rerenderOnGuiAttached = _useState2[1];

    var colId = column.colId;
    var columnState = api.getColumnState();
    var currenColumnIndex = columnState.findIndex(function (_ref) {
        var filterValue = _ref.colId;
        return filterValue === colId;
    });
    var currentPinnedValue = (0, _lodash2.default)(columnState, currenColumnIndex + '.pinned', null);

    var afterGuiAttached = (0, _react.useCallback)(function () {
        rerenderOnGuiAttached({});
    }, []);

    (0, _agGridReact.useGridFilter)({
        afterGuiAttached: afterGuiAttached
    });

    var onChange = function onChange(_ref2) {
        var value = _ref2.value;

        var newColumnState = [].concat(_toConsumableArray(columnState));
        if (currenColumnIndex >= 0) {
            newColumnState[currenColumnIndex] = Object.assign({}, newColumnState[currenColumnIndex], {
                pinned: value
            });
        }

        api.applyColumnState({
            state: newColumnState,
            applyOrder: true
        });
        if (onColumnStateChanged) {
            onColumnStateChanged({
                columnState: (0, _dataGridUtils.lockColumnsPin)(api.getColumnDefs(), newColumnState)
            });
        }
    };
    var options = [{ value: null, label: notPinnedLabel }, { value: 'left', label: leftPinnedLabel }];
    var currentOptions = options.filter(function (_ref3) {
        var value = _ref3.value;
        return value !== currentPinnedValue;
    });

    return _react2.default.createElement(
        'div',
        null,
        currentOptions.map(function (_ref4) {
            var value = _ref4.value,
                label = _ref4.label;
            return _react2.default.createElement(
                'button',
                {
                    key: value,
                    onClick: function onClick() {
                        return onChange({ value: value });
                    },
                    className: styles['item']
                },
                label
            );
        })
    );
};

ColumnMenu.propTypes = {
    api: _propTypes2.default.object,
    column: _propTypes2.default.object,
    context: _propTypes2.default.object,
    leftPinnedLabel: _propTypes2.default.string,
    notPinnedLabel: _propTypes2.default.string
};